<template>
  <v-menu
    offset-y
    :[alignMenu]="true"
  >
    <template v-slot:activator="{ on }">
      <BaseButton
        :has-icon="true"
        class="ma-0 pa-4"
        :size="size"
        v-on="on"
        @click="$emit('onClick')"
      >
        <v-icon>more_vert</v-icon>
      </BaseButton>
    </template>

    <v-list>
      <v-list-item
        v-for="menu, index in filteredMenuItens"
        :key="index"
        class="pa-0"
      >
        <BaseButton
          v-if="!menu.disableButton(itemData)"
          type="text"
          :is-disabled="menu.disableButton(itemData)"
          button-class="base-menu-options--button"
          @click="menu.execute(itemData)"
        >
          <v-icon
            v-if="menu.icon"
            small
            class="mr-2"
          >
            {{ menu.icon }}
          </v-icon> {{ menu.text }}
        </BaseButton>
        <v-tooltip
          v-else
          bottom
          open-on-hover
        >
          <template v-slot:activator="{ on }">
            <span
              class="pa-0 v-list-item"
              v-on="on"
            >
              <BaseButton
                type="text"
                :is-disabled="menu.disableButton(itemData)"
                button-class="base-menu-options--button"
                @click="menu.execute(itemData)"
              >
                {{ menu.text }}
              </BaseButton>
            </span>
          </template>
          <span> {{ menu.tooltipText }}</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    menuItens: {
      type: Array,
      required: true
    },
    itemData: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) => ['x-small', 'small', 'medium', 'large', 'x-large'].includes(value)
    },
    alignMenu: {
      type: String,
      required: false,
      default: 'right',
      validator: (value) => ['right', 'left', 'top', 'bottom'].includes(value)
    }
  },
  computed: {
    filteredMenuItens() {
      return this.menuItens.filter(menu => !menu.hideButton(this.itemData))
    }
  }
}
</script>

<style scoped>
  .base-menu-options--button {
    width: 100%!important;
    margin: 0px !important;
    color: var(--custom-theme-black-087) !important;
    display: flex!important;
    justify-content: flex-start!important;
  }

  .base-menu-options--button >>> span {
    font-weight: normal!important;
  }
</style>
